export function translate(key) {
    return window.translations?.[key] ?? key
}

export function setCookie(name, value, days) {
    const json = JSON.stringify(value)
    const encoded = encodeURIComponent(json)
    const daysInMilliseconds = days * 24 * 60 * 60 * 1000
    const expires = new Date(Date.now() + daysInMilliseconds).toUTCString()

    document.cookie = `${name}=${encoded}; path=/; expires=${expires}`
}

export function getCookie(name, defaultValue = null) {
    const match = document.cookie.match(
        new RegExp(
            '(?:^|; )' +
                name.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&') +
                '=([^;]*)'
        )
    )

    if (!match) {
        return defaultValue
    }

    try {
        return JSON.parse(decodeURIComponent(match[1]))
    } catch {
        return defaultValue
    }
}
